// Si el usuario trabaja las promos de varias cadenas: abarca el silo y no trae una cadena propia,
// porque con una LEVEL_1 en el token el back opera siempre sobre esa.
import type { RoleAssignmentInfoLocal } from '@/api/types/MeLocal';
import { resolveOwnRetailerId } from '@/domains/retail/ventas/lib/retailerScope';

export function choosesRetailers(assignments: readonly RoleAssignmentInfoLocal[]): boolean {
    const coversSilo = assignments.some(
        (assignment) => assignment.scope === 'TENANT' || assignment.scope === 'PLATFORM',
    );
    return coversSilo && !assignments.some((assignment) => assignment.scope === 'LEVEL_1');
}

/** Elige cadenas, o la cadena fija del usuario; `null` si no tiene una sola. */
export function resolvePromotionsRetailerScope(assignments: readonly RoleAssignmentInfoLocal[]): {
    canChoose: boolean;
    fixedRetailerId: string | null;
} {
    const canChoose = choosesRetailers(assignments);
    return { canChoose, fixedRetailerId: canChoose ? null : resolveOwnRetailerId(assignments) };
}
